import actions from './actions';
import actionTypes from './constants/action-types';
import middleware from './middleware';
import reducers from './reducers';
import selectors from './selectors';

export default {
  actions,
  actionTypes,
  middleware,
  reducers,
  selectors,
};
